@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.location

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.models.Language
import com.narbase.letsgo.router.EndPoint

object GetPassengerGeocodeEndpoint : EndPoint<GetPassengerGeocodeEndpoint.Request, GetPassengerGeocodeEndpoint.Response>() {
    class Request(
        val lat: Double,
        val lng: Double,
        val onIdle: Boolean?,
        val language: DtoName<Language>
    )

    class Response(
        val address: String,
        val isFavorite: Boolean,
    )
}